export default __webpack_public_path__ + "static/media/p10.0a7d490c.jpg";